import { Component, forwardRef, Injector } from '@angular/core';
import { IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-splitline',
  templateUrl: './r-splitline.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RSplitlineComponent),
      multi: true
    }
  ]
})
export class RSplitlineComponent extends RenderComponentBase {
  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {}
  static KEY = 'r-d-splitline';
}
